// @flow
import type { IDDActionType } from './actions';
import type { StateType } from '../../reducers';
import type { CountryType } from '../../../config/iddCountries';

export default (state: IDDStateType = {}, action: IDDActionType): IDDStateType => {
  switch (action.type) {
    case 'SET_IDD_COUNTRY':
      return {
        ...state,
        country: action.payload.country,
      };
    default:
      return state;
  }
};

const iddStateSelector = (state: StateType): ?IDDStateType => state.international.idd;

export const iddZoneSelector = (state: StateType): ?string => {
  const iddState = iddStateSelector(state);
  return iddState?.country?.iddZone;
};

export type IDDStateType = {
  country?: CountryType,
};
